import { HttpClient } from '@angular/common/http';
import { Injectable, computed, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AutoConfig } from '../../interfaces/autoconfig.interface';
import { URLs } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly _config = signal<AutoConfig | null>(null);
  readonly errorLoading = signal(false);

  readonly nombreSistema  = computed(() => this._config()?.nombreSistema  ?? '');
  readonly siglasSistema  = computed(() => this._config()?.sigla           ?? '');
  readonly version        = computed(() => this._config()?.version         ?? '');
  readonly manualLoginEnabled = computed(() => this._config()?.manualLogin === 'true');

  constructor(private readonly http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.http.get<AutoConfig>(URLs.autoConfigController)
      );
      this._config.set(config);
      this.errorLoading.set(false);
      if (config.nombreSistema) {
        document.title = config.nombreSistema;
        console.log('[ConfigService] document.title =', document.title);
      }
    } catch (error) {
      this.errorLoading.set(true);
      console.error('Error al cargar la configuración del sistema:', error);
    }
  }

  get config(): AutoConfig | null {
    return this._config();
  }

  get isLoaded(): boolean {
    return this._config() !== null;
  }
}
